var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"preloader"}),_c('div',{attrs:{"id":"main-wrapper"}},[_c('top-nav'),_c('side-nav'),_c('router-view'),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"copyright"},[_c('p',[_vm._v("Copyright © TrustEarns 2018 - "+_vm._s((()=>new Date().getFullYear())()))])])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }